var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentCard',{attrs:{"id":"available-subscription","title":"Subscriptions"}},[_c('PlanInfo',{attrs:{"id":"available-plan-info"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }